import * as React from 'react';
import Button from 'react-bootstrap/Button';

import './style.scss';

interface IEditButtonProps {
  onClick: TButtonOnClick;
  className?: string;
  isDisabled?: boolean;
}

interface IEditButtonState {}

export default class EditButton extends React.Component<IEditButtonProps, IEditButtonState> {
  static defaultProps: IEditButtonProps = {
    onClick: () => null,
    className: '',
    isDisabled: false,
  };

  render() {
    const { onClick, className } = this.props;

    return (
      <Button
        className={`edit-btn ${className}`}
        onClick={(event) => onClick(event)}
        disabled={this.props.isDisabled}
      />
    );
  }
}
